/**
 * Identidade do produto Nolens (ADR-039). Todos os subprodutos partilham o símbolo, a
 * tipografia e o nó teal; só a cor muda (Business azul, Personal roxo, Physio verde,
 * Athletics vermelho). Para outro produto: mudar estes valores, os de `--brand-*` e
 * `--accent` em packages/ui/src/tokens.css, e correr `pnpm brand:icons`.
 */
export const PRODUCT = {
  name: 'Physio',
  /** Fundo do símbolo (tile). */
  tile: '#1F4633',
  /** Cor do descritor e cor de ação por omissão (a clínica pode escolher a sua). */
  accent: '#48795C',
  /** Descritor em modo escuro (contraste AA sobre as superfícies escuras). */
  accentOnDark: '#7DB892',
} as const;

export const DEFAULT_ACCENT = PRODUCT.accent;
